// queries/useGetForumGenerations.ts
"use client";
import { useInfiniteQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_FORUM_GENERATIONS, GET_MODEL_CREATIONS } from "api";
import { useAppContext } from "hooks";
import { ResponseGeneration } from "types";

const fetchGenerations = async (
  key: string,
  pageParam: number = 1,
  pageSize: number = 8,
  isUserModelPath: boolean
): Promise<ResponseGeneration[]> => {
  if (isUserModelPath) {
    return fetch(`${GET_MODEL_CREATIONS(key)}?page=${pageParam}&page_size=${pageSize}`);
  } else {
    return fetch(`${GET_FORUM_GENERATIONS(key)}?page=${pageParam}&page_size=${pageSize}`);
  }
};

export const useGetGenerations = (pageSize = 8, key?: string, isUserModelPath: boolean = false) => {
  const { jwt } = useAppContext();

  // @ts-ignore
  return useInfiniteQuery({
    queryKey: ["generations", key, isUserModelPath],
    queryFn: ({ pageParam = 1 }) =>
      fetchGenerations(key!, pageParam as any, pageSize, isUserModelPath),
    getNextPageParam: (lastPage, allPages) => {
      const nextPage = allPages.length + 1;
      // @ts-ignore
      return nextPage <= Math.ceil(lastPage.total_image_generations / pageSize)
        ? nextPage
        : undefined;
    },
    enabled: !!key && !!jwt && !location.pathname.includes("mymodels"),
  });
};

export default useGetGenerations;
